import './Polyfills'
import React, { useEffect } from 'react';
// The imports of the libraries used to make the drag-and-drop work.
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

// Importing the Bootstrap library before the CSS of the project itself to enable overrides.
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Imports of the components and function used within the application.
import Left from './components/Left'
import Main from './components/Main'
import Right from './components/Right'
// import { sortData } from './Utils'
import { COLORS } from './Constants'
import { useStateValue } from './components/StateProvider'

function App() {
  const [{ darkmode }, dispatch] = useStateValue()

  useEffect(() => {
    dispatch({
      type: 'UPDATE_OUTER_WIDTH',
      item: window.outerWidth,
    })

    fetch('https://disease.sh/v3/covid-19/all')
      .then(response => response.json())
      .then(data => {
        console.log(data)
      })
    fetch('https://disease.sh/v3/covid-19/countries')
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: 'UPDATE_COUNTRY_STATS',
          item: data,
        })
        dispatch({
          type: 'UPDATE_LEGEND_TITLES',
          item: Object.keys(data[0]),
        })
      })
  }, [dispatch])


  return (
    <DndProvider backend={HTML5Backend}>
      <div className='application' style={{
        backgroundColor: darkmode ? COLORS.main_bg_color_dark : COLORS.main_bg_color_light,
        color: darkmode ? COLORS.main_font_color_dark : COLORS.main_font_color_light,
      }}>
        <Left></Left>
        <Main></Main>
        <Right></Right>
      </div>
    </DndProvider>
  )
}

export default App
